/**
 * Loyalty — orchestrator for the /loyalty page.
 *
 * The CheckPointsModal is mounted globally by App.js (so the header
 * "Check Points" button works from any route), so this page only owns
 * the static content + the open-modal triggers. We do NOT render the
 * modal here — that would double-mount it and produce two
 * `[data-testid="loyalty-modal"]` nodes (see iteration_28 finding).
 *
 * CheckPointsModal is still re-exported below because App.js imports it
 * from this module.
 */
import SEOHead from "../components/SEOHead";
import { useLoyalty } from "../lib/loyalty";

import CheckPointsModal from "./loyalty/CheckPointsModal";
import LoyaltyHero from "./loyalty/LoyaltyHero";
import LoyaltyRedemption from "./loyalty/LoyaltyRedemption";
import LoyaltyReferrals from "./loyalty/LoyaltyReferrals";

export { CheckPointsModal };

export default function Loyalty() {
    const { openModal } = useLoyalty();
    const handleOpen = () => openModal?.();

    return (
        <>
            <SEOHead
                title="ZenCircle Rewards — ZenZest's NY Cannabis Loyalty Program"
                description="Earn points on every purchase at ZenZest Queens & Staten Island. Five tiers, redeem for dollars off, refer a friend and stack rewards. Free to join."
                canonical="https://weeddispensarynearme.com/loyalty"
            />
            <LoyaltyHero onOpenModal={handleOpen} />
            <LoyaltyRedemption onOpenModal={handleOpen} />
            <LoyaltyReferrals onOpenModal={handleOpen} />
        </>
    );
}
